import React from "react";
import { Container, Row, Col } from "reactstrap";

const CapabilitiesGrid = ({ data }) => {
    if (!data) return null;

    const { tagline, title, description, items, styles } = data;

    return (
        <section
            className="capability"
            style={{
                background: styles?.background || "#fff",
                padding: "80px 0"
            }}
        >
            <Container>
                {/* Header */}
                <div className="sec-head text-center mb-5">
                    <p className="eyebrow">
                        {tagline}
                    </p>
                    <h2 className="mb-3" style={{ color: styles?.titleColor }}>
                        {title}
                    </h2>
                    <p className="mx-auto" style={{ maxWidth: "750px" }}>
                        {description}
                    </p>
                </div>

                {/* Cards */}
                <Row className="g-4 cap-grid">
                    {items.map((item, index) => (
                        <Col md={6} lg={3} key={index}>
                            <div className="capability-card text-center h-100 p-4">
                                <div className="capability-icon">{item.icon}</div>
                                <h3 className="fw-bold mt-3">{item.title}</h3>
                                <p className="text-muted mt-2">
                                    {item.description}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default CapabilitiesGrid;